module.exports = __webpack_public_path__ + "static/media/Huis-3-2.c9b0f3b1.jpg";